import { render, staticRenderFns } from "./Zhishi.vue?vue&type=template&id=520410d5&scoped=true&"
import script from "./Zhishi.vue?vue&type=script&lang=js&"
export * from "./Zhishi.vue?vue&type=script&lang=js&"
import style0 from "./Zhishi.vue?vue&type=style&index=0&id=520410d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520410d5",
  null
  
)

export default component.exports